<div class="ipg">
  <div class="ipg__header header">
    <div class="header__day">
      <button mat-icon-button class="htv-selectable htv-force-direction" (click)="goToPreviousDay()">
        <mat-icon>&#xe5cb;</mat-icon>
      </button>
      <div class="header__day__text mat-body-medium">{{ currentScrollTime | momentp: 'ddd DD MMM' }}</div>
      <button mat-icon-button class="htv-selectable htv-force-direction" (click)="goToNextDay()">
        <mat-icon>&#xe5cc;</mat-icon>
      </button>
    </div>
    <div class="header__timeline timeline">
      <button mat-icon-button class="timeline__left-scroll htv-selectable htv-force-direction" (click)="scrollLeft()">
        <mat-icon>&#xe5cb;</mat-icon>
      </button>
      <div #timeline class="timeline__times">
        <div class="timeline__cursor mat-body-small" [style.left]="cursorOffset - minOffset - timelineOffset + 'px'">
          {{ cursorTime }}
        </div>
        <ng-container *ngFor="let time of times">
          <div
            class="timeline__times__time mat-body-small"
            [style.left]="time.offset - minOffset - timelineOffset + 'px'">
            <span>{{ time.value }}</span>
          </div>
        </ng-container>
      </div>
      <button mat-icon-button class="timeline__right-scroll htv-selectable htv-force-direction" (click)="scrollRight()">
        <mat-icon>&#xe5cc;</mat-icon>
      </button>
    </div>
  </div>

  <div class="ipg__inner channels">
    <div class="channels__row" *ngFor="let channel of channels">
      <div class="channels__row__desc">
        <div class="channel-name">
          <span>{{ channel.name }}</span>
        </div>
        <div class="channel-logo">
          <img [attr.src]="channel.logoUrl" [attr.alt]="channel.name" />
        </div>
      </div>
      <div #program class="channels__row__programs">
        <ng-container *ngFor="let ipgProgram of channelsIPG[channel.id].programs; let i = index">
          <ng-container *ngIf="i !== channelsIPG[channel.id].programs.length - 1; else lastProgram">
            <div
              class="program htv-selectable htv-autoclick htv-force-direction {{
                channel.id === selectedChannel.id && i === selectedProgramIndex ? 'htv-focus' : ''
              }}"
              [style.width]="ipgProgram.width + 'px'"
              [style.left]="ipgProgram.offset - minOffset + 'px'"
              (click)="onClick($event, channel, ipgProgram, i)">
              <div class="program__inner" [style.background-color]="ipgProgram.categoryColor">
                <ng-container *ngIf="ipgProgram.program">
                  <span class="text-ellipsis">{{ ipgProgram.program | programTitle: locale }}</span>
                </ng-container>
              </div>
            </div>
          </ng-container>
          <ng-template #lastProgram>
            <div
              class="program"
              [style.width]="ipgProgram.width + 'px'"
              [style.left]="ipgProgram.offset - minOffset + 'px'"
              [style.visibility]="'hidden'">
              <div class="program__inner">
                <span class="text-ellipsis"> {{ ipgProgram.start | momentp }} - {{ ipgProgram.end | momentp }} </span>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="ipg__categories categories">
    <div class="categories__category" *ngFor="let category of categories">
      <div class="categories__category__color" [style.background-color]="category.color"></div>
      <span>{{ category.name }}</span>
    </div>
  </div>

  <div class="ipg__program-details program-details">
    <div class="program-details__preview">
      <img [attr.src]="selectedChannel.logoUrl" alt="" />
    </div>
    <div class="program-details__info">
      <div class="mat-title-large text-ellipsis">
        {{ selectedProgram.program | programTitle: locale }}
      </div>
      <div class="mat-body-medium text-ellipsis">
        {{ selectedProgram.start | momentp }} - {{ selectedProgram.end | momentp }}
        {{ selectedProgram.program?.category ? ' | ' + selectedProgram.program?.category : '' }}
      </div>
      <div class="program-details__info__summary mat-body-medium">
        {{ selectedProgram.program | programDescription: locale }}
      </div>
    </div>
  </div>
</div>
